<div style="background-color: #1976d2;  border: 1px solid #1976d2">
    <div class="container">
        <div class="nav_glt">
            <div class="copyrights">
                &copy; 2006-{{curYear}}. {{langData.defdata.rights}}
            </div>
        </div>
    </div>
</div>